import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <div className="relative bg-black text-white overflow-hidden py-24 sm:py-32" data-id="element-17">
      {/* Subtle background texture/pattern using CSS gradients */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#c9a96e 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-18" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6" data-id="element-20">
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif tracking-wide text-gold-400" data-id="element-21">
            Seetaluxuryescape
          </h1>
        </motion.div>

        <motion.div initial={{
        width: 0
      }} animate={{
        width: '80px'
      }} transition={{
        duration: 1,
        delay: 0.5,
        ease: 'easeInOut'
      }} className="h-px bg-gold-400 mb-8" data-id="element-22" />

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="max-w-2xl text-lg sm:text-xl text-white font-light tracking-wide" data-id="element-23">
          Curating Extraordinary Journeys
        </motion.p>
      </div>
    </div>;
}